import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Login from './pages/Login';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';

import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Projects from './pages/Projects';
import Bookings from './pages/Bookings';
import BookingDetail from './pages/BookingDetail';
import Payments from './pages/Payments';
import Commissions from './pages/Commissions';
import Users from './pages/Users';

const App = () => (
  <>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route
          path="leads"
          element={
            <PrivateRoute roles={['admin', 'sales', 'support']}>
              <Leads />
            </PrivateRoute>
          }
        />
        <Route path="projects" element={<Projects />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="bookings/:id" element={<BookingDetail />} />
        <Route
          path="payments"
          element={
            <PrivateRoute roles={['admin', 'sales', 'support']}>
              <Payments />
            </PrivateRoute>
          }
        />
        <Route
          path="commissions"
          element={
            <PrivateRoute roles={['admin', 'sales', 'support']}>
              <Commissions />
            </PrivateRoute>
          }
        />
        <Route
          path="users"
          element={
            <PrivateRoute roles={['admin', 'support']}>
              <Users />
            </PrivateRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
    <ToastContainer position="top-right" autoClose={2500} />
  </>
);

export default App;
